import React from "react";
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import {
  landing as landingRoutes,
  dashboard as dashboardRoutes,
  page as pageRoutes,
} from "./index";

import DashboardLayout from "../layouts/Dashboard";
import LandingLayout from "../layouts/Landing";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import SignIn from "../pages/auth/SignIn";


import ScrollToTop from "../components/ScrollToTop";

const childRoutes = (Layout, routes) =>
  routes.map(({
    children,
    path,
    component: Component },
    index,
  ) =>
    children ? (
      // Route item with children
      children.map(({ path, component: Component }, index) => (
        <Route
          key={index}
          path={path}
          exact
          render={props => (
            <Layout>
              <Component {...props} />
            </Layout>
          )}
        />
      ))
    ) : (
      // Route item without children
      <Route
        key={index}
        path={path}
        exact
        render={props => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    )
  );

  const privateRoutes = (Layout, routes, auth) => {
    if(!auth.loading){
      if(!auth.isAuthenticated && !auth.loading){
        return (
          <Route
            render={props => (
              <Redirect to="/auth/sign-in"/>
            )}
          />
        )
      } else {
        return (
          childRoutes(DashboardLayout, dashboardRoutes)
        )
      }
    }
  }




const Routes = ({auth}) => (
  <Router>
    <ScrollToTop>
      <Switch>
        {childRoutes(LandingLayout, landingRoutes)}
        {childRoutes(AuthLayout, pageRoutes)}
        {privateRoutes(DashboardLayout, dashboardRoutes, auth)}
        <Route
          render={() => (
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          )}
        />
      </Switch>
    </ScrollToTop>
  </Router>
);


const mapStateToProps = state => ({
  auth: state.auth
})

export default connect(mapStateToProps)(Routes);
